import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogHeader,
  DialogTitle,
  DialogContent,
} from "@/components/ui/dialog";
import { toast } from "@/hooks/use-toast";
import { useDeleteTransaction } from "@/services/mutations/transactions";
import { useTranslation } from "react-i18next";

interface DeleteTransactionDialogProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  id?: string;
  refetch: () => void;
  onSuccess?: () => void;
}

const DeleteTransactionDialog = ({
  visible,
  setVisible,
  id,
  refetch,
  onSuccess,
}: DeleteTransactionDialogProps) => {
  const { t } = useTranslation();
  const { mutate: deleteTransaction, isPending: isDeleting } =
    useDeleteTransaction({
      onSuccess: () => {
        setVisible(false);
        refetch();
        toast({
          title: t("success_message.title"),
          description: t("success_message.delete_transaction_description"),
        });
        onSuccess?.();
      },
    });
  return (
    <Dialog open={visible} onOpenChange={setVisible}>
      <DialogContent>
        <DialogHeader className="text-left">
          <DialogTitle>{t("title.delete_transaction")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-start justify-center gap-[10px]">
          <p className="text-white">
            {t("label.delete_transaction_description")}
          </p>
          <div className="flex w-full flex-row items-center justify-end gap-[10px]">
            <Button
              variant="outline"
              onClick={() => setVisible(false)}
              className="w-full"
            >
              {t("button.cancel")}
            </Button>
            <Button
              className="w-full"
              onClick={() => {
                setVisible(false);
                if (id) {
                  deleteTransaction({ id });
                }
              }}
              disabled={isDeleting}
            >
              {t("button.delete_transaction")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteTransactionDialog;
